import type { CcmConfigResponse } from '@arhs-fleetback/types/entities/ccm';
import { combineReducers } from 'redux';

import { SELECT_DEALER } from 'constants/ActionTypes';
import type { Action } from 'modules/global/generic.types';
import error from 'modules/global/reducers/generic.error';
import loading from 'modules/global/reducers/generic.loading';
import { SELECT_GROUP } from 'modules/groups/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

import { CLEAR_CCM_DATA, FETCH_CCM_CONFIG, FETCH_CCM_CONFIG_SUCCESS } from '../actionTypes';

export default combineReducers({
  data: createReducer<CcmConfigResponse | null>(null, {
    [FETCH_CCM_CONFIG_SUCCESS]: (_, { payload }: Action<CcmConfigResponse>) => payload ?? null,
    [SELECT_DEALER]: () => null,
    [SELECT_GROUP]: () => null,
    [CLEAR_CCM_DATA]: () => null,
  }),
  isFetching: loading(FETCH_CCM_CONFIG),
  error: error(FETCH_CCM_CONFIG),
});
